import React, { useEffect, useState } from 'react';

import { Badge, Drawer, Fab } from '@mui/material';
import ForumIcon from '@mui/icons-material/Forum';
import { observer } from 'mobx-react';
import { getService } from 'react-in-angularjs';
import { StreamChat } from 'stream-chat';

import { angularizeWithProviders } from '../../../shared/providers';
import { LbChat } from './LbChat/LbChat';
import { chatStore } from '../../stores/chatStore';
import classes from './NgzChatModal.module.scss';
import { loggedInUserDataStore } from '../../../shared/stores/loggedInUserDataStore';
import { solutionsStore } from '../../../shared/stores/solutionsStore';

const apiKey = process.env.APP_STREAM_API_KEY as string;

const ChatModal = observer(() => {
  const [unreadCount, setUnreadCount] = useState(0);

  const {
    user,
    userToken,
    chatClient,
    setChatClient,
    getChatInfo,
    setIsOpenChat,
    isOpenChat,
    resetChat,
  } = chatStore;

  useEffect(() => {
    initChatData();

    return resetChat;
  }, []);

  useEffect(() => {
    if (!chatClient && userToken) {
      initChat();
    }
  }, [userToken]);

  const initChatData = async () => {
    await getChatInfo();
  };

  const initChat = async () => {
    if (!user || !userToken) {
      throw new Error(
        'Chat client cannot be initialized because user or user token is not set',
      );
    }

    const client = StreamChat.getInstance(apiKey, {
      timeout: 0, // fix canceled requests after 3s (default)
    });

    const { id, name, imageUrl } = user;
    await client.connectUser({ id, name, image: imageUrl }, userToken);
    watchUnreadCount(client);
    setChatClient(client);
  };

  const watchUnreadCount = (client: StreamChat) => {
    client.on((event) => {
      if (event.total_unread_count !== undefined) {
        setUnreadCount(event.total_unread_count);
      }
    });
  };

  const onOpenHandler = () => setIsOpenChat(true);
  const onCloseHandler = () => setIsOpenChat(false);

  return (
    <>
      <Badge className={classes.chatBtn} badgeContent={unreadCount} color="error">
        <Fab onClick={onOpenHandler} color="primary" aria-label="Open chat">
          <ForumIcon fontSize="large" />
        </Fab>
      </Badge>
      <Drawer open={isOpenChat} onClose={onCloseHandler} anchor="right">
        <div className={classes.chatWrapper}>
          <LbChat />
        </div>
      </Drawer>
    </>
  );
});

// TODO remove this component after all components will be migrated to React
const NgzChatModal = observer(() => {
  const AuthService = getService('AuthService');
  const { loggedInUser } = loggedInUserDataStore;
  const { activeSolutionFlags } = solutionsStore;

  if (!loggedInUser?.id || activeSolutionFlags.SCAN_IQ || activeSolutionFlags.CHALLENGE) {
    return null;
  }

  const isPaymentIssue = AuthService.getSelfBillingPaymentIssue(loggedInUser);
  if (isPaymentIssue) {
    return null;
  }

  return <ChatModal />;
});

angularizeWithProviders(NgzChatModal, 'ngzChatModal', {});

export { NgzChatModal, ChatModal };
